(function() {

    /**
     * @type BasketBlock
     */
    var BasketBlock = (/** @constructor */ function() {

        /** @type {Object} параметры */
        var opt = {
            emptyText : 'пуста',
            linkText : ''
        };

        var $obj;

        return {
            /**
             * @memberOf BaksetBlock
             * @param {Object} options
             */
            init : function(options) {
                $.extend(opt, options);
                $obj = $(opt.selector);

            },

            /**
             * Обновить поле корзины
             * @param {Number} count кол-во товаров
             * @param {Number} summ общая стоимость
             */
            update : function(count, summ) {
                if (count > 0) {
                    var gs = 'товаров',
                        d100 = count % 100,
                        d10 = count % 10;
                    if ((d100 < 5) || (d100 > 20)) {
                        if (d10 == 1) {
                            gs = 'товар';
                        } else  if (d10 < 5) {
                            gs = 'товара';
                        }
                    }
					$obj.removeClass('empty');
                    $obj.find('.badge').html(count);
                    $obj.find('.count').html(count);
                    $obj.find('.price').html(parseFloat(summ).toPrice());
                    if(count > 0){
                        $obj.find('.btn-basket').removeClass('hidden');
                    }

                } else {
                    $obj.find('.btn-basket').addClass('hidden');
//					$obj.addClass('empty');
//                    $obj.find('.b-basket_line2').html('' + opt.emptyText + '');
                }
            }

        };
    })();
    Order.BasketBlock = BasketBlock;

})();